"use client"
import { useEffect } from "react"
import { useUser } from "@clerk/nextjs"
import { usePathname } from "next/navigation"
import { identifyUser, initDatadogBrowser, resetUser } from "@/infrastructure/datadog-browser"
export function DatadogProvider({ children }: { children: React.ReactNode }) {
  const consentPage = usePathname() === "/oauth-consent"
  useEffect(() => { if (!consentPage) initDatadogBrowser() }, [consentPage])
  return <>{!consentPage && process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY ? <Identity /> : null}{children}</>
}
function Identity() {
  const { isLoaded, isSignedIn, user } = useUser()
  useEffect(() => {
    if (!isLoaded) return
    if (isSignedIn && user?.id) identifyUser(user.id)
    else resetUser()
  }, [isLoaded, isSignedIn, user?.id])
  return null
}
